import api from '@/api.js';
const state = {
    items: {}
};
const mutations = {
    list(state, items) {
        state.items = items;
    },
};
const getters = {
    items: (state) => state.items
};
const actions = {
    async add({ commit }, data) {
        await api.bike.add(data);
    },
    async list({ commit }, params) {
        const res = await api.bike.list(params);
        commit('list', res.data);
    }
};
export const Bike = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
